import React, { Component } from 'react';
import { Text } from './../common';
import styled from 'styled-components';
import { Flex } from 'rebass';
import { colors, shadows } from '../../tailwind';

import Link from '../../components/Link';

export default class DashboardNav extends Component {
  render() {
    // let location;
    // if (history && history.location) {
    //   location = history.location.pathname;
    // }
    const { location } = this.props;
    const dashboardRoutes = ['/dashboard'];
    const inboxRoutes = ['/inbox'];
    const listingRoutes = ['/dashboard/listings'];
    const reviewRoutes = ['/user/reviews'];
    const reservationRoutes = ['/reservation/current', '/reservation/previous'];
    const profileRoutes = ['/user/edit', '/user/photo', '/user/photo'];
    const accountRoutes = [
      '/user/payout',
      '/user/transaction',
      '/users/security',
    ];

    return (
      <NavBar>
        {
          // <DsabhoardLink isActive={dashboardRoutes.indexOf(location) >= 0}>
          //   <Link to={'/dashboard'}>
          //     <Text clickable grayDarkMedium>
          //       Dashboard
          //     </Text>
          //   </Link>
          // </DsabhoardLink>
        }
        <DsabhoardLink isActive={inboxRoutes.indexOf(location) >= 0}>
          <Link to={'/inbox'}>
            <Text clickable grayDarkMedium>
              Inbox
            </Text>
          </Link>
        </DsabhoardLink>
        <DsabhoardLink isActive={listingRoutes.indexOf(location) >= 0}>
          <Link to={'/dashboard/listings'}>
            <Text clickable grayDarkMedium>
              My Listings
            </Text>
          </Link>
        </DsabhoardLink>
        <DsabhoardLink isActive={reviewRoutes.indexOf(location) >= 0}>
          <Link to={'/user/reviews'}>
            <Text clickable grayDarkMedium>
              Reviews
            </Text>
          </Link>
        </DsabhoardLink>
        {
          // <DsabhoardLink isActive={reservationRoutes.indexOf(location) >= 0}>
          //   <Link to={'/reservation/current'}>
          //     <Text clickable grayDarkMedium>
          //       Reservations
          //     </Text>
          //   </Link>
          // </DsabhoardLink>
        }
        <DsabhoardLink isActive={profileRoutes.indexOf(location) >= 0}>
          <Link to={'/user/edit'}>
            <Text clickable grayDarkMedium>
              Profile
            </Text>
          </Link>
        </DsabhoardLink>
        <DsabhoardLink isActive={accountRoutes.indexOf(location) >= 0}>
          <Link to={'/user/payout'}>
            <Text clickable grayDarkMedium>
              Account
            </Text>
          </Link>
        </DsabhoardLink>
      </NavBar>
    );
  }
}

const NavBar = styled(Flex)`
  height: 49px;
  background-color: #ffffff;
  padding-left: 32px;
  width: 100%;
  box-shadow: ${shadows.default};
`;

const DsabhoardLink = styled.div`
  border-bottom: ${p =>
    p.isActive ? `4px solid ${colors.primaryDark}` : null};
  margin-right: 32px;
  vertical-align: center;
  padding-top: 15px;
`;



// WEBPACK FOOTER //
// ./src/components_new/dashboard/DashboardNav.js